/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Divider from '@material-ui/core/Divider';

const styles = (theme) => ({
    divider: {
        backgroundImage: 'linear-gradient(90deg,#000 30%,hsla(0,0%,100%,0) 0)',
        backgroundPosition: 'bottom',
        backgroundSize: theme.spacing(1),
        width: '100%',
        margin: theme.spacing(4, 0),
    },
});

const ProductDivider = ({ classes }) => <Divider className={classes.divider} />;

ProductDivider.propTypes = {
    classes: object.isRequired,
};

export default withStyles(styles)(ProductDivider);
